import { CdkDropList, type CdkDragDrop } from '@angular/cdk/drag-drop';
import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
    output,
} from '@angular/core';
import { DocumentDragState } from '../../pack-document/document-drag-state';
import { QuippyPackDocument } from '../../pack-document/pack-document';
import { ProposalState } from '../../proposal-state';
@Component({
    selector: 'qpx-quippy-pack-excluded-documents',
    imports: [CdkDropList, QuippyPackDocument],
    templateUrl: './excluded-documents.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuippyPackExcludedDocuments {
    protected readonly draft = inject(ProposalState);
    protected readonly documentDrag = inject(DocumentDragState);
    public readonly actionId = input.required<string>();
    public readonly disabled = input(false);
    public readonly changed = output<void>();
    public readonly moved = output<string>();
    protected dropExcluded(event: CdkDragDrop<string, string, string>): void {
        if (this.disabled() || !event.isPointerOverContainer) return;
        if (this.draft.moveDocument(event.item.data, '')) this.changed.emit();
    }
}
